import useApiMutation from 'shared/hooks/use-api-mutation';
import {OrderProps, OrderStatus} from '../types';
import useUpdateOrder from '../util/use-update-orders';

const useCancelOrder = (orderId: string) => {
  const updateOrder = useUpdateOrder();

  const onSuccess = (data: OrderProps) =>
    updateOrder(data, OrderStatus.canceled);

  return useApiMutation({
    url: `/orders/${orderId}/canceled`,
    method: 'DELETE',
    errorTitle: 'Erro ao cancelar pedido',
    successTitle: 'Alteração de status do pedido',
    successMessage: 'Pedido cancelado!',
    onSuccess,
  });
};

export default useCancelOrder;
